var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "fullblock" }, [
            _c("div", { staticClass: "row no-margin" }, [
              _c("div", { staticClass: "col-6" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "notifications-container" }, [
                  _c(
                    "div",
                    { staticClass: "notification-block" },
                    [
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            variant: "primary",
                            show: "",
                            dismissible: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    This is an example top alert. You can edit what u wish. (primary)\n                                "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "notification-block" },
                    [
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            variant: "secondary",
                            show: "",
                            dismissible: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    This is an example top alert. You can edit what u wish. (secondary)\n                                "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "notification-block" },
                    [
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            variant: "success",
                            show: "",
                            dismissible: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    This is an example top alert. You can edit what u wish. (success)\n                                "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "notification-block" },
                    [
                      _c(
                        "b-alert",
                        {
                          attrs: { variant: "info", show: "", dismissible: "" }
                        },
                        [
                          _vm._v(
                            "\n                                    This is an example top alert. You can edit what u wish. (Info)\n                                "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "notification-block" },
                    [
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            variant: "danger",
                            show: "",
                            dismissible: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    This is an example top alert. You can edit what u wish. (danger)\n                                "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "notification-block" },
                    [
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            variant: "warning",
                            show: "",
                            dismissible: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    This is an example top alert. You can edit what u wish. (warning)\n                                "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "notification-block" },
                    [
                      _c(
                        "b-alert",
                        {
                          attrs: { variant: "light", show: "", dismissible: "" }
                        },
                        [
                          _vm._v(
                            "\n                                    This is an example top alert. You can edit what u wish. (light)\n                                "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "notification-block" },
                    [
                      _c(
                        "b-alert",
                        {
                          attrs: { variant: "dark", show: "", dismissible: "" }
                        },
                        [
                          _vm._v(
                            "\n                                    This is an example top alert. You can edit what u wish. (dark)\n                                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "notifications-container" }, [
                  _c(
                    "div",
                    { staticClass: "notification-block" },
                    [
                      _c("b-alert", { attrs: { show: "", dismissible: "" } }, [
                        _vm._v(
                          "\n                                    This is an example top alert. You can edit what u wish.\n                                "
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "notification-block" },
                    [
                      _c("b-alert", { attrs: { show: "", dismissible: "" } }, [
                        _vm._v(
                          "\n                                    This is an example top alert. You can edit what u wish.\n                                "
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "notification-block" },
                    [
                      _c("b-alert", { attrs: { show: "", dismissible: "" } }, [
                        _vm._v(
                          "\n                                    This is an example top alert. You can edit what u wish.\n                                "
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "notification-block" },
                    [
                      _c("b-alert", { attrs: { show: "", dismissible: "" } }, [
                        _vm._v(
                          "\n                                    This is an example top alert. You can edit what u wish.\n                                "
                        )
                      ])
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("Notifications")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "notifications-top-block" }, [
      _c("span", [_vm._v("Alert with different color")]),
      _vm._v(" "),
      _c("p", [_vm._v("use the class alert alert-*colors* for dezier")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "notifications-top-block" }, [
      _c("span", [_vm._v("Alert with image / icon")]),
      _vm._v(" "),
      _c("p", [_vm._v("add the image / icon before content`")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58dfa508", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58dfa508","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications.vue
// module id = null
// module chunks = 